const getOnClearHandler = ({ onChange, setSearchTerm }) => () => {
  const searchTerm = "";
  onChange({ searchTerm });
  setSearchTerm(searchTerm);
};

export default getOnClearHandler;
